var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artworks, undefined) {
buf.push("<div class=\"responsive-layout-container\"><div class=\"rva-container main-layout-container\"><div class=\"rva-header avant-garde-s-headline\">Recently Viewed</div><div class=\"rva-content\"><div class=\"rva-images\">");
// iterate artworks
;(function(){
  var $$obj = artworks;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artwork = $$obj[$index];

buf.push("<div" + (jade.attr("data-artwork-id", artwork._id, true, true)) + " class=\"rva-artwork-image-container artwork-item\"><a" + (jade.attr("href", artwork.href, true, true)) + " class=\"analytics-rva-artwork-thumbnail\"><img" + (jade.attr("src", artwork.image.thumb.url, true, true)) + (jade.attr("alt", artwork.title, true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"rva-artwork-image\"></a><div class=\"overlay-container\"><div data-test=\"saveArtwork\" class=\"overlay-button-save\"></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artwork = $$obj[$index];

buf.push("<div" + (jade.attr("data-artwork-id", artwork._id, true, true)) + " class=\"rva-artwork-image-container artwork-item\"><a" + (jade.attr("href", artwork.href, true, true)) + " class=\"analytics-rva-artwork-thumbnail\"><img" + (jade.attr("src", artwork.image.thumb.url, true, true)) + (jade.attr("alt", artwork.title, true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"rva-artwork-image\"></a><div class=\"overlay-container\"><div data-test=\"saveArtwork\" class=\"overlay-button-save\"></div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div>");}.call(this,"artworks" in locals_for_with?locals_for_with.artworks:typeof artworks!=="undefined"?artworks:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;